export const FETCH_VOICE = "FETCH_VOICE"
export const FETCH_VOICE_SUCCESS = "FETCH_VOICE_SUCCESS"
export const FETCH_VOICE_FAILED = "FETCH_VOICE_FAILED"
export const RESET_VOICE = "RESET_VOICE";
